// Form autosave. A field being filled in must survive an accidental refresh,
// a dropped connection, or a stray navigation (brief: "Formulaires non
// perdus"). Drafts live in localStorage under a namespaced key; screens restore
// on mount, write on input, and clear once the form is committed or abandoned.

const PREFIX = 'circle:draft:';

export function loadDraft<T>(key: string): Partial<T> | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as Partial<T>) : null;
  } catch {
    return null;
  }
}

export function saveDraft(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* storage full or unavailable — autosave is best-effort */
  }
}

export function clearDraft(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}

/**
 * Wire a set of inputs so their combined values are written to a draft on every
 * keystroke and reported back through `read`. Returns a `commit`/`discard` pair
 * the caller invokes when the form is saved or left.
 */
export function autosave(
  key: string,
  fields: Iterable<HTMLInputElement | HTMLTextAreaElement>,
  read: () => Record<string, string>,
): { commit: () => void; discard: () => void } {
  const write = () => saveDraft(key, read());
  for (const el of fields) el.addEventListener('input', write);
  return {
    commit: () => clearDraft(key),
    discard: () => clearDraft(key),
  };
}
